import { MenuItem } from "@mui/material";
import { Participant } from "../../interfaces/interfaces";
import axios from "axios";
import { useSnackbar } from "notistack";
import React from "react";

import { SearchParticipantContext } from "../../context/searchParticipantContext";
import { User, AppContext } from "../../../../context/appContext";
import { endpoints } from "../../../../endpoints/endpoints";

const AnonymizeUser = ({
  participant,
  handleClose,
}: {
  participant: Participant;
  handleClose: (event: React.MouseEvent<HTMLElement> | null) => void;
}): React.JSX.Element => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    startSearch,
  }: {
    startSearch: () => void;
  } = React.useContext(SearchParticipantContext);

  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const [doubleCheck, setDoubleCheck] = React.useState(false);

  const handleClick = () => {
    if (!doubleCheck) {
      setDoubleCheck(true);
      return;
    }

    anonymizeUserRequest();
    setDoubleCheck(false);
    handleClose(null);
  };

  const anonymizeUserRequest = async (): Promise<void> => {
    await axios
      .post(endpoints.admin.anonymizeUserData, {
        sessionId: user.sessionId,
        participantId: participant.participantId,
      })
      .then(async (response) => {
        checkSession(response);

        if (response.data.status === "success") {
          enqueueSnackbar("Teilnehmer erfolgreich anonymisiert", {
            variant: "success",
          });
          startSearch();
        } else {
          enqueueSnackbar("Fehler beim anonymisieren des Teilnehmers", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error changing participant status", error);
      });
  };

  const getMenuItemText = (): string => {
    if (doubleCheck) return "Sind Sie sicher?";
    if (participant.status === 0) return "Anonymisieren (inaktive)";
    return "Anonymisieren";
  };

  return (
    <MenuItem
      disabled={participant.status === 0}
      onClick={handleClick}
      sx={{
        wordBreak: "all",
      }}
    >
      {getMenuItemText()}
    </MenuItem>
  );
};

export default AnonymizeUser;
